import { render, staticRenderFns } from "./AddNewsletter.vue?vue&type=template&id=0863e148"
import script from "./AddNewsletter.vue?vue&type=script&lang=js"
export * from "./AddNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports